import React, { useContext } from 'react'
import { BodyText } from '@paypalcorp/pp-react'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { formatMessage } from '../../../utils/localization/format_worldready'
import { isDetailsV1Dot1Enabled } from '../../../utils/features'

import * as styles from './closingDate.css'

interface ClosingDateProps {
  closingDate?: string

  isSmallerScreen?: boolean
  formattedClosingDate?: string
}

export const ClosingDate = ({
  closingDate,
  isSmallerScreen,
  formattedClosingDate,
}: ClosingDateProps) => {
  const isNewDetailsUI = isDetailsV1Dot1Enabled()
  const worldReadyC = useContext(WorldReadyContext)
  const contentId = isNewDetailsUI
    ? 'flatProgress.chipInUntil'
    : 'flatProgress.acceptingContributionsUntil'
  const chipUntilDate: string = formatMessage({
    worldReady: worldReadyC,
    contentId,
    formatOptions: { closing_date: closingDate },
  })

  if (isNewDetailsUI) {
    return (
      <BodyText
        as="p"
        className={styles.chipInDate}
        data-testid="closingDateV1Dot1"
      >
        {chipUntilDate}
      </BodyText>
    )
  }

  if (isSmallerScreen) {
    return null
  }

  return (
    <BodyText as="p" className={styles.closingDate} data-testid="closingDate">
      {formattedClosingDate}
    </BodyText>
  )
}
